import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import setAuthHeader from '../services/axiosService';
// import { storeUser } from '../redux/actions/authAction';
import { loadUserFromStorage, signinSilent, signoutRedirect } from '../services/authService';
import useUserActivity from '../hooks/useUserActivity';
import { handleShowSessionTimeOutModal } from '../components/EpSessionTimeOutModal';

export default function AuthProvider({ userManager: manager, store, children }) {
  const userManager = useRef();
  useUserActivity();

  const activityState = useSelector(state => state.modal.isActive);
  const userActivityModalVisibility = useSelector(state => state.modal.isOpened);

  useEffect(() => {
    userManager.current = manager;

    const onUserLoaded = () => {
      loadUserFromStorage();
    };

    const onUserUnloaded = () => {
      setAuthHeader(null);
    };

    const onAccessTokenExpiring = () => {
      const isActive = activityState;

      if (isActive === true) {
        signinSilent();
      } else {
        handleShowSessionTimeOutModal(null, true);
      }
    };

    const onAccessTokenExpired = () => {
      const isActive = activityState;

      // Caso o usuário não esteja ativo no sistema e não selecione a opção de continuar logado
      // Será deslogado do sistema
      if (isActive === true && userActivityModalVisibility === false) {
        signinSilent();
      } else {
        signoutRedirect();
      }
    };

    const onUserSignedOut = () => {
      console.log('User signed out');
    };

    userManager.current.events.addUserLoaded(onUserLoaded);
    userManager.current.events.addUserUnloaded(onUserUnloaded);
    userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
    userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.current.events.addUserSignedOut(onUserSignedOut);

    return function cleanup() {
      userManager.current.events.removeUserLoaded(onUserLoaded);
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring);
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
  }, [manager, store, activityState]);

  return React.Children.only(children);
}
